enum Mutations {
  SET_SHIFTPLAN = 'setShiftplan',
  SET_SLOT_DISPLAY_STYLE = 'setSlotDisplayStyle',
  SET_FREE_RANGE_INTERVAL = 'setFreeRangeInterval',
  SET_TIMEFRAME = 'setTimeframe'
}

export default Mutations;
